import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { EllipsisHorizontalIcon, TrashIcon } from "@heroicons/react/20/solid";
interface Props {
  disabled: boolean;
  onRemove: () => void;
}
export default function RecipeActions({ disabled, onRemove }: Props) {
  return (
    <Menu as="div" className="relative">
      <MenuButton
        type="button"
        disabled={disabled}
        aria-label="Recipe actions"
        title="Recipe actions"
        className="inline-flex h-11 w-11 items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 disabled:opacity-50 sm:h-9 sm:w-9"
      >
        <EllipsisHorizontalIcon className="h-5 w-5" aria-hidden="true" />
      </MenuButton>
      <MenuItems className="absolute right-0 z-30 mt-1 w-48 rounded-lg border border-slate-200 bg-white p-1 shadow-lg focus:outline-none">
        <MenuItem>
          <button
            type="button"
            onClick={onRemove}
            className="flex min-h-[44px] w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-red-700 data-[focus]:bg-red-50"
          >
            <TrashIcon className="h-4 w-4" aria-hidden="true" />
            Remove recipe
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
